import Vue from 'vue'
import Vuex from 'vuex'
//挂载Vuex
Vue.use(Vuex)
//创建VueX对象
const store = new Vuex.Store({
    // 共享状态（即变量）
    state:{
      // 机型数组
      modelList: "",
      // app渠道号
      appChannelList: "",
      appChannelInfoList: [],
      // 渠道号
      channelList: "",
      // 系统id
      systemId: null,
      // 系统名称
      sysName: null,
      // 前缀
      sysPrefix: null,
      // url
      sysUrl: null,
      // 首页url
      indexUrl: null,

      esUrl: null,
      // tab当前选中的path
      activePath: '',
      // 菜单项-tab
      tabList: [],
      tabIndex: 0,
      json: {}
    },
    // 更改vuex的store中状态的唯一方法 - 同步操作
    mutations: {
      // 设置机型id
      setModelList(state, ids ) {
        state.modelList = ids
      },
      // 设置app渠道
      setAppChannelList(state, channelNo) {
        state.appChannelList = channelNo
      },
      setAppChannelInfoList(state, channelNo) {
        state.appChannelInfoList = channelNo
      },
      // 设置渠道
      setChannel(state, channel) {
        state.channelList = channel
      },
      // 设置系统id
      setSystem(state, id) {
        state.systemId = id
      },
      // 设置前缀
      setSysName(state, sysName) {
        state.sysName = sysName
      },
      // 设置前缀
      setSysPrefix(state, sysPrefix) {
        state.sysPrefix = sysPrefix
      },
      setSysUrl(state, sysUrl) {
        state.sysUrl = sysUrl
      },
      setIndexUrl(state, indexUrl) {
        state.indexUrl = indexUrl
      },
      // 添加菜单
      selectMenu(state, newRoute) {
        // tab当前选中的path
        let exist = state.tabList.findIndex((item) => {
          return item.path === newRoute.path
        })
        if (exist === -1) {
          state.tabList = state.tabList.concat(newRoute);
          state.tabIndex = state.tabList.length - 1;
        }else {
          if (newRoute.params!=null && newRoute.params.id !=null) {
            state.tabList[exist].params = newRoute.params
          }
          if (newRoute.query !=null && newRoute.query.id !=null) {
            state.tabList[exist].query = newRoute.query
          }
          state.tabIndex = exist
        }
      },
      initTabRouterList(state, tabList) {
        state.tabList = tabList
      },
      subtractCurrentTabRouter(state, newRoute) {
        const { index } = newRoute;
        state.tabList = state.tabList.slice(0, index).concat(state.tabList.slice(index + 1));
      },
      // tab当前选中的
      changeMenu(state, val) {
        if(val !== undefined) {
          state.activePath = val
        }
      },
      closeCurrTab(state){
        let index = state.tabIndex;
        state.tabList = state.tabList.slice(0, index).concat(state.tabList.slice(index + 1));
      },
    },
    // 和mutations类似，异步操作
    Action: {

    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js